import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { fetchData } from "./Utilities";

const ConvertCoinToRlsModal = ({
  isOpen,
  closeModal,
  onExit,
  onExited,
  userId,
}) => {
  const [userInfo, setUserInfo] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const saveCoins = async (coinsNumber) => {
    if (coinsNumber?.trim() === "" || !coinsNumber) {
      setErrorMessage("لطفا تعداد سکه ها را وارد نمایید.");
      return;
    }
    setErrorMessage(null);
    // const bodyFormData = new FormData();
    // bodyFormData.append("guid", Cookies.get("guid"));
    // bodyFormData.append("mob", userInfo?.mob);
    // bodyFormData.append("coin", coinsNumber);

    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("coin", coinsNumber);
    fetchData("convertcointorls", bodyFormData, handleApiResponse);

    // fetchData("giftcoin", bodyFormData, handleGiftApiResponse);
  };
  const handleApiResponse = (data) => {
    closeModal();
    SweetAlert({
      title: "",
      text: data,
      type: "success",
    });
  };

  // useEffect(() => {
  //   const bodyFormData = new FormData();
  //   bodyFormData.append("guid", Cookies.get("guid"));
  //   bodyFormData.append("coin", coinsNumber);
  //   fetchData("convertcointorls", bodyFormData, handleApiResponse);
  // }, []);

  const [coinsNumber, setCoinsNumber] = useState(null);
  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      onExit={onExit}
      onExited={onExited}
      centered
    >
      <Modal.Header>
        <div className="m-auto maxh-20 fw-bold text-secondary ">
          تبدیل سکه پارسی به ريال
        </div>

        <button
          className="btn-close bg-danger text-white"
          onClick={() => closeModal()}
        />
      </Modal.Header>
      <Modal.Body
        className="justify-content-center mx-4
            "
      >
        <p>
          {" "}
          {/* {userInfo?.name} {userInfo?.family} */}
          تعداد سکه پارسی برای تبدیل به ریال را وارد کنید:
        </p>
        <p> {userInfo?.mob}</p>
        {/* <label>تعدد سکه ها:</label> */}
        <input
          className={`w-100 p-1 text-center form-control `}
          minLength="1"
          maxLength="20"
          type="number"
          placeholder="تعداد سکه ها را وارد نمایید"
          onChange={(e) => setCoinsNumber(e.target.value)}
          required={true}
        />
      </Modal.Body>
      {errorMessage && (
        <p className="text-danger text-center">{errorMessage}</p>
      )}
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={() => saveCoins(coinsNumber)}>
          ذخیره
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConvertCoinToRlsModal;
